<template>
  <div>
    <v-card
      id="card"
      class="card-text px-1 rounded-0"
      color=""
      style=""
    >
      <v-row>
        <v-col class="my-auto py-0">
          <v-row>
            <v-col cols="8">
              <v-row>
                <v-col cols="6" class="">
                  {{ item.DayName }}
                </v-col>
                <v-col cols="6" class="">{{ item.DDate }}</v-col>
              </v-row>
              <v-row class="py-0 my-0">
                <v-col>
                  <div class="text-caption text-caption-color">
                    <span class="font-sahel">
                      ( {{ $t("DurationTime") }} :{{ item.Duration4 }} )</span
                    >
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              cols="4"
              style="
                justify-content: left;
                align-content: center;
                display: flex;
              "
            >
              
            </v-col>
          </v-row>
        </v-col>
        <v-col class="my-auto py-0" cols="auto">
          <v-btn icon @click="show = !show" class="card-text">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-expand-transition class="">
        <div v-show="show" class="mt-1">
          <v-row>
            <v-col>
              <v-row>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("EntryTime") }} : <span class="text-value">{{ item.ioBT }}</span>
                </v-col>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("ExitTime") }} : <span class="text-value">{{ item.ioET }}</span>
                </v-col>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Title") }} : <span class="text-value">{{ item.Title1 }}</span>
                </v-col>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Duration") }} : <span class="text-value">{{ item.Duration1 }}</span>
                </v-col>
                 <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Title") }} : <span class="text-value">{{ item.Title2 }}</span>
                </v-col>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Duration") }} : <span class="text-value">{{ item.Duration2 }}</span>
                </v-col>
                 <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Title") }} : <span class="text-value">{{ item.Title3 }}</span>
                </v-col>
                <v-col cols="6" class="my-auto py-0"
                  >{{ $t("Duration") }} : <span class="text-value">{{ item.Duration3 }}</span>
                </v-col>
                
              </v-row>
            </v-col>
            <v-col cols="auto py-0">
              <div style="width: 36px; height: 36px"></div>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>